var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "master_svg0_1291_000222"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFC28D",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF5858",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.125,6Q11.125,6.97756,10.76517,7.88649Q10.37446,8.873380000000001,9.62392,9.62392Q8.873380000000001,10.37446,7.88649,10.76517Q6.97756,11.125,6,11.125Q5.02244,11.125,4.11351,10.76517Q3.12661,10.37446,2.37608,9.62392Q1.6255389999999998,8.873380000000001,1.234835,7.88649Q0.875,6.97756,0.875,6Q0.875,5.02244,1.234835,4.11351Q1.6255389999999998,3.12662,2.37608,2.37608Q3.12662,1.6255389999999998,4.11351,1.234835Q5.02244,0.875,6,0.875Q6.97756,0.875,7.88649,1.234835Q8.873380000000001,1.6255389999999998,9.62392,2.37608Q10.37446,3.12661,10.76517,4.11351Q11.125,5.02244,11.125,6Z",
    fillRule: "evenodd",
    fill: "url(#master_svg0_1291_000222)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5151699999999995,5.7348300000000005L5.515242,3.734912C5.444839,3.6645088,5.349456,3.625,5.25,3.625C5.042893,3.625,4.875,3.792893,4.875,4C4.875,4.099456,4.9145088,4.194839,4.984835,4.265165L6.71967,6L4.984835,7.73483C4.9145088,7.80516,4.875,7.90054,4.875,8C4.875,8.20711,5.042893,8.375,5.25,8.375C5.349456,8.375,5.444839,8.33549,5.515165,8.26516L5.515165,8.26516L7.5151699999999995,6.2651699999999995C7.66161,6.11872,7.66161,5.88128,7.5151699999999995,5.7348300000000005Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.727297,8.4773L7.7273,6.4773Q7.925,6.27959,7.925,6Q7.925,5.72041,7.7273,5.5227L5.727374,3.52278Q5.529594,3.325,5.25,3.325Q4.9704058,3.325,4.772703,3.522703Q4.575,3.7204058,4.575,4Q4.575,4.279594,4.772703,4.477297L6.29541,6L4.772703,7.5227Q4.575,7.72041,4.575,8Q4.575,8.279589999999999,4.772703,8.4773Q4.9704062,8.675,5.25,8.675Q5.529594,8.675,5.727297,8.4773ZM7.30303,5.94697Q7.35607,6,7.30303,6.05303L5.303033,8.05303Q5.281066,8.075,5.25,8.075Q5.175,8.075,5.175,8Q5.175,7.96893,5.196967,7.94697L7.14393,6L5.196967,4.053033Q5.175,4.031066,5.175,4Q5.175,3.925,5.25,3.925Q5.281066,3.925,5.30311,3.947044L7.30303,5.94697Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon2);
export default __webpack_public_path__ + "media/ArrowIcon2.72fb7d3c.svg";
export { ForwardRef as ReactComponent };